export const transfeeraConfig = {
  id: 'transfeera',
  assets: '/assets',
  name: 'Transfeera',
  showStatusMenu: true
};
